module.exports = __webpack_public_path__ + "static/media/layout-background.f88a7d68.svg";